export default __webpack_public_path__ + "static/media/rtvV.86060d1f.png";